<template>
	<!-- 具体可参考src/components/common/tagManage/Core.vue文件
<transition-group class="mt05x cb ml05x_E mt05x_E fL_E" v-on:leave="el=>{transitionAction('hide',el);}" :duration="500">
	<TagBox v-for="tag in tagList" :key="tag.id" :val="tag.name" :data="tag" @Remove="onRemove(tag.id)"></TagBox>
</transition-group>
 -->
	<div
		class="tagBox vaM"
		:class="[styleType == 'def' ? 'mrB' : 'tag', { bgDisable: styleType == 'def', 'bgPrimary-low cPrimary': styleType == 'tag' }, getSizeClass]"
	>
		<div class="cb" :title="outData(val)">
			<div class="content">
				<span v-if="title">{{ title + ": " }}</span>
				<span v-if="iVal" :class="{ cMain: title && styleType == 'def' }">{{ outData(iVal) }}</span>
			</div>
			<div v-if="removeButton" class="removeButton" @click="remove">
				<button class="hover-f-error">
					<Icon name="no" class="w105x h105x" :class="{ 'fSub hover-f-error': styleType == 'def', fWhite: styleType == 'tag' }" />
				</button>
			</div>
		</div>
		<slot></slot>
	</div>
</template>
<script>
export default {
	components: {},
	props: {
		title: {
			type: String,
			default: "",
		},
		data: {
			type: Object,
			default: null,
		},
		val: {
			type: [String, Array],
			default: "",
		},
		styleType: {
			type: String,
			default: "def", //def:默认样式，类似于高级筛选生效项目；tag：生效标签的显示；
		},
		size: {
			type: String,
			default: "m",
		},
		removeButton: {
			//移除按钮控制
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			iVal: this.val,
		};
	},
	watch: {
		val: function (val, oldVal) {
			if (val === "") {
				//仅删除ui
				this.remove(false);
			} else if (val === undefined || val === null) {
				//非正常值进行移除动作
				// this.$nextTick(()=>{
				// 	this.iVal=oldVal;console.log(this.val,this.iVal)
				// });
				this.remove();
			} else {
				//正常值，展示或更新值
				if (this.iVal === this.val) {
					//第一次运行使用动画展示
					this.show();
				} else this.iVal = this.val; //已展示，只需更新
			}
		},
	},
	methods: {
		outData(val) {
			if ($.type(val) == "array") return val.join(" ");
			else return val;
		},
		show: function () {
			let $this = $(this.$el);
			let ml = $this.css("margin-left");
			let tW = $this.innerWidth(); //.find(".tagBox")
			$this
				.css({
					transition: "none",
					// display: "table",
					width: 0,
					opacity: 0,
					"margin-left": 0,
				})
				.removeClass("show")
				.stop(true, true)
				.animate(
					{
						opacity: 1,
						width: tW,
						"margin-left": ml,
					},
					500,
					"easeInOutExpo",
					function () {
						//清空因动画产生的样式
						$this.css({
							transition: "",
							// display: "",
							width: "",
							opacity: "",
							"margin-left": "",
						});
						// setTimeout(lib.fillHeight,100);
					}
				);
		},
		// hide:function(fn){
		// 	$(this.$el).css({"transition": "none"}).stop(true,true).animate({
		// 		opacity: 0,
		// 		width: 0,
		// 		"margin-left":0,
		// 		"padding":0
		// 	},500,"easeInOutExpo",()=>{
		// 		if(fn) fn();
		// 	});
		// },
		remove(emit = true) {
			// this.hide();
			if (emit !== false) this.$emit("Remove", this.iVal, this.data);
		},
	},
	created() {},
	computed: {
		getSizeClass: function () {
			let size = "";
			if (this.styleType == "tag") {
				//tag样式就是小尺寸
				size = "sizeS";
			} else {
				switch (this.size) {
					case "s":
						size = "sizeS";
						break;
					case "m":
					default:
						size = "sizeM";
						break;
				}
			}
			return size;
		},
	},
	mounted() {
		this.show();
	},
};
</script>
<style lang="scss" scoped>
.tagBox {
	padding: {
		right: 1rem;
		left: 1rem;
	}
	display: inline-block;
	margin-top: 0.25rem;
	margin-right: 0.5rem;
	margin-bottom: 0.25rem;
	border-radius: $radiusLight;
	.content {
		float: left;
		max-width: 30rem;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.removeButton {
		display: inline-block;
		margin-left: 1.5rem;
		svg {
			padding: 0;
			fill: rgba($black, 0.25);
		}
	}
	& + .tagBox {
		margin: {
			left: 0.5rem;
		}
	}
	// &.tag+.tag{margin:{left:.5rem;};}
}
.sizeS {
	height: 2.25rem;
	font-size: $fsLv1;
	line-height: 2.25rem;
	padding: {
		right: 0.5rem;
		left: 0.5rem;
	}
}
.sizeM {
	height: 2.75rem;
	line-height: 2.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ui/TagBox.vue